import React from 'react';

const TermsOfServicePage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Sayfa Başlığı ve Giriş Bölümü */}
                <header className="text-center mb-12 md:mb-16">
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Kullanım Koşulları
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Mekânname uygulamasını kullanarak, aşağıda belirtilen kullanım koşullarını kabul etmiş olursunuz. Lütfen bu koşulları dikkatlice okuyun.
                    </p>
                </header>

                {/* İçerik Bölümleri */}
                <main className="space-y-8">
                    {/* Hizmetin Kabulü */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            1. Kullanım Koşullarının Kabulü
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Mekânname uygulaması, size bu koşulları kabul etmeniz şartıyla sunulmaktadır. Uygulamayı kullanmaya devam etmeniz, bu koşulları kabul ettiğiniz anlamına gelir.
                        </p>
                    </section>

                    {/* Hizmetin Kullanımı */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            2. Hizmetin Kullanımı
                        </h2>
                        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                            <li>
                                <span className="font-semibold text-white">Yüklenen İçerik:</span> Uygulamaya yüklediğiniz fotoğraflar ve içerikler sizin sorumluluğunuzdadır. Yasalara aykırı, telif hakkı ihlali içeren veya uygunsuz içerik yüklememeniz gerekir.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Davranış Kuralları:</span> Diğer kullanıcıları rahatsız edecek veya uygulamaya zarar verecek herhangi bir faaliyette bulunamazsınız.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Hesap Güvenliği:</span> Hesabınızın güvenliğini sağlamak sizin sorumluluğunuzdadır. Şifrenizi gizli tutmalı ve hesabınızdaki tüm etkinliklerden siz sorumlu olursunuz.
                            </li>
                        </ul>
                    </section>

                    {/* Fikri Mülkiyet Hakları */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            3. Fikri Mülkiyet Hakları
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Mekânname uygulamasının tüm içeriği, yazılımı, logoları ve tasarımları Mekânname'ye aittir ve telif hakkı ile korunmaktadır. Uygulama içinde yer alan içerikleri izinsiz kullanamaz, kopyalayamaz veya dağıtamazsınız.
                        </p>
                    </section>
                    
                    {/* Sorumluluğun Sınırlandırılması */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            4. Sorumluluğun Sınırlandırılması
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Mekânname, uygulamanın kesintisiz ve hatasız çalışacağını garanti etmez. Uygulamanın kullanımından doğabilecek zararlardan dolayı Mekânname sorumlu tutulamaz.
                        </p>
                    </section>
                    
                    {/* Değişiklikler */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            5. Kullanım Koşullarında Değişiklikler
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Bu kullanım koşulları, herhangi bir zamanda önceden bildirimde bulunulmaksızın değiştirilebilir. Değişiklikler, yayınlandığı tarihte yürürlüğe girer. Uygulamayı kullanmaya devam etmeniz, bu değişiklikleri kabul ettiğiniz anlamına gelir.
                        </p>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default TermsOfServicePage;